import config from '../config.json';

export function decodeHTMLEntities(text: string): string {
  return text.replace(/&([\da-z#]{1,7});/g, (match, dec) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (config.knownEntities[dec as never] !== undefined) {
      return config.knownEntities[dec as never];
    }

    if (dec[0] === '#') {
      dec = dec.slice(1);
      return String.fromCharCode(Number(dec[0] === 'x' ? `0${dec}` : dec));
    }

    return match;
  });
}
